import { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function EnquiryModal() {
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    user_name: "",
    user_number: "",
    useremail: "",
    shipment_value: ""
  });
  const handleClose = () => {
  setShowModal(false);

  localStorage.setItem("modalClosed", "true");
};

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "user_name") {
      value = value.replace(/[^a-zA-Z ]/g, "").replace(/^\s+|\s{2,}/g, " ");
    }

    if (name === "user_number") {
        value = value.replace(/\D/g, "").slice(0, 10);
        if (value.length === 1 && !/[6-9]/.test(value)) {
        return;
        }
    }
    if (name === "shipment_value") {
      value = value.replace(/\D/g, "").slice(0, 100);
      if (value.length === 1 && !/[0-9]/.test(value)) {
        return;
      }
    }

    setFormData({ ...formData, [name]: value });
  };

  const isValidEmail = (email) => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(formData.useremail)) {
      Swal.fire("Error", "Invalid email", "error");
      return;
    }

    const url = `https://docs.google.com/forms/d/e/1FAIpQLSemDtdC5MV9kP7zSimbpt3WtkPrFtBgwdYvbP5tQZ77vff9JA/formResponse?&submit=Submit?usp=pp_url&entry.331191442=${formData.user_name}&entry.783604537=${formData.user_number}&entry.315175843=${formData.useremail}&entry.116302553=${formData.shipment_value}`;

    try {
      await fetch(url, {
        method: "POST",
        mode: "no-cors" // important for Google Forms
      });

      Swal.fire({
        title: "Form Submitted!",
        text: "Thank you! Your details have been submitted successfully. We’ll get back to you shortly.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });
      setFormData({
        user_name: "",
        user_number: "",
        useremail: "",
        shipment_value: ""
      });
      setTimeout(() => {
        setShowModal(false);
      }, 1000);

    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  return (
    <>
      <button className="btn btn-primary" onClick={() => setShowModal(true)}>
        Become a Franchise  <i className="fas fa-long-arrow-right"></i>
      </button>

      {/* Modal */}
      <div className={`modal fade ${showModal ? "show d-block" : ""}`}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Enquiry now</h5>
              <button className="btn-close" onClick={handleClose}></button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>

                <div className="mb-3">
                  <label>Full Name <span>*</span></label>
                  <input
                    type="text"
                    name="user_name"
                    className="form-control"
                    placeholder="e.g. Rohit Sharma"
                    value={formData.user_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label>Mobile Number <span>*</span></label>
                  <input
                    type="text"
                    name="user_number"
                    pattern="[6789][0-9]{9}"
                    className="form-control"
                    value={formData.user_number}
                    onChange={handleChange}
                    placeholder="e.g. 9876543210"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label>Email <span>*</span></label>
                  <input
                    type="email"
                    name="useremail"
                    className="form-control"
                    value={formData.useremail}
                    onChange={handleChange}
                    placeholder="e.g. rahul@gmail.com"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label>Monthly Shipment Count <span>*</span></label>
                  <input
                    type="text"
                    name="shipment_value"
                    className="form-control"
                    value={formData.shipment_value}
                    onChange={handleChange}
                    placeholder="Estimated monthly shipment volume (e.g. 500)"
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button>

              </form>
            </div>

          </div>
        </div>
      </div>

      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}